import { useId } from "react";

/** App identity only. The oval and custom letterforms follow GPS's existing
 * mark; CSS supplies the selected theme's colour. Reports/issued documents
 * continue to use the original, fixed-blue logo3-clean.png independently. */
export default function GpsHeaderMark() {
  const paint = `gps-header-${useId()}`;
  return (
    <svg className="gps-header-mark" viewBox="0 0 1066 593" width="1066" height="593"
      aria-hidden="true" focusable="false">
      <defs>
        <linearGradient id={paint} x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" className="gps-mark-start" />
          <stop offset="1" className="gps-mark-end" />
        </linearGradient>
      </defs>
      <rect x="9" y="9" width="1048" height="575" rx="287.5" fill={`url(#${paint})`} />
      <rect x="40" y="40" width="986" height="513" rx="256.5" fill="none" stroke="#fff" strokeWidth="18" />
      <g fill="#fff">
        <path d="M395 167H255C182 167 123 225 123 298S181 429 255 429H396V275H309C283 275 271 291 255 321H348V382H253C208 382 171 345 171 298S208 214 253 214H395Z" />
        <path d="M437 167H599C643 167 678 202 678 248S643 329 599 329H484V429H437V282H598C616 282 631 267 631 248S616 214 598 214H437Z" />
        <path d="M929 167H778C734 167 699 202 699 247C699 288 730 321 775 321H855C873 321 887 335 887 352C887 370 874 383 855 383H744C721 383 705 402 700 429H855C899 429 935 395 935 352S899 275 855 275H778C760 275 746 262 746 245C746 228 760 214 778 214H883C909 214 923 197 929 167Z" />
      </g>
    </svg>
  );
}
